<template>
  <main>
    <b-modal
      id="requestonboardingdocs"
      size="xl"
      centered
      :visible="showRequestDocs"
      hide-footer
      hide-header
      no-close-on-backdrop
      @hidden="$emit('close-modal')"
    >
      <b-overlay :show="LoaderStatus" rounded="sm">
        <main>
          <div class="d-flex align-items-center justify-content-between p-3">
            <div class="b-modal-header">Request Onboarding Documents</div>
            <div class="rotate-on-hover pointer">
              <img
                @click="$emit('close-modal')"
                v-b-tooltip.hover.top="'Close'"
                src="@/assets/img/accessconnew/blueCross.svg"
                alt
              />
            </div>
          </div>
          <hr class="my-0" />
          <section class="p-2">
            <div
              class="
                gap-10
                d-flex
                justify-content-between
                align-items-center
                w-100
                pt-3
                pl-3
                pr-3
                pb-0
              "
            >
              <div class="exc-seacrh position-relative w-100">
                <span>
                  <img
                    class="search-pos"
                    src="@/assets/img/search-bar-icon.svg"
                    alt
                  />
                </span>
                <b-form-input
                  class="search-input"
                  type="search"
                  placeholder="Search"
                  debounce="500"
                  @update="searchDocs"
                  v-model="searchQuery"
                ></b-form-input>
              </div>

              <div class="bluebtn">
                <b-button
                  @click="
                    (currentLabel = null),
                      (action = 'add'),
                      (showAddNewDoc = true)
                  "
                  class="
                    acs-addBtn-modal
                    padding-6-30
                    d-flex
                    align-items-center
                    bluebtn
                  "
                >
                  <img
                    src="@/assets/img/accessconnew/whitePlus.svg"
                    alt
                    class="mr-2"
                  />
                  <span>Document</span>
                </b-button>
              </div>
            </div>
            <section class="mt-2">
              <div
                class="exc-main-table"
                style="height: calc(100vh - 310px) !important"
              >
                <div class="exc-table-head">
                  <div class="common-single-checkbox pl-3" style="width: 5%">
                    <b-form-checkbox
                      :disabled="documents.fields.length == 0"
                      v-model="allSelected"
                      @change="selectAllDocs()"
                    ></b-form-checkbox>
                  </div>
                  <div style="width: 20%">
                    <span>Name</span>
                    <template v-if="sortType !== null">
                      <img
                        @click="sortObjectsByKey(false)"
                        v-if="sortType"
                        class="pointer table-sort-icons ml-2"
                        src="@/assets/panelist/up_sort.svg"
                        alt
                      />
                      <img
                        v-else
                        @click="sortObjectsByKey(true)"
                        class="pointer table-sort-icons ml-2"
                        src="@/assets/panelist/down_sort.svg"
                        alt
                      />
                    </template>
                    <img
                      v-else
                      @click="sortObjectsByKey(true)"
                      class="pointer table-sort-icons ml-2"
                      src="@/assets/panelist/no_sort.svg"
                      alt
                    />
                  </div>
                  <div style="width: 20%">
                    <span>Accepted File Type</span>
                  </div>
                  <div class style="width: 13%">
                    <span>Multiple Files</span>
                  </div>
                  <div style="width: 12%" class>
                    <span class>Required</span>
                  </div>
                  <div style="width: 20%">
                    <span>Dowload Template</span>
                  </div>

                  <div style="width: 10%">
                    <span class>Actions</span>
                  </div>
                </div>

                <div class="exc-table-body" id="top1">
                  <template
                    v-if="documents.fields.length === 0 && !LoaderStatus"
                  >
                    <div
                      class="
                        h-100
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <div class="text-center">
                        <div>
                          <img src="@/assets/panelLog/searchnotfoundpan.svg" />
                        </div>
                        <div
                          v-if="searchQuery !== ''"
                          class="tp-basic-black-txt mt-2 wordbreak"
                        >
                          No matching results for
                          <strong>"{{ searchQuery }}"</strong>
                        </div>
                        <div v-else class="tp-basic-black-txt mt-2 wordbreak">
                          No data found.
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <!-- :style="
                    candidateSelected.includes(i.candidateID) &&
                    'background : #E1EEF7 !important'
                    "-->
                    <div
                      v-for="field in documents.fields"
                      :key="field.key"
                      class="reqdocs-table-row mt-3"
                    >
                      <div
                        v-if="field.createdByRec"
                        class="blue-gradientcard"
                        style="top: -12px !important"
                      >
                        Created By You
                      </div>
                      <div class="tp-gridgreencolorDynamic"></div>
                      <div style="width: 5%" class="pl-3">
                        <div class="common-single-checkbox">
                          <b-form-checkbox
                            :value="field.key"
                            v-model="selectedDocs"
                            @change="deselect()"
                          ></b-form-checkbox>
                        </div>
                      </div>
                      <div class="mr-1" style="width: 20%">
                        <div
                          class="text-truncate truncate-section"
                          v-b-tooltip.hover.top="field.label"
                        >
                          {{ field.label }}
                        </div>
                      </div>
                      <div style="width: 20%">
                        <div
                          class="text-truncate truncate-section"
                          v-b-tooltip.hover.top="field.fileFormat.join(', ')"
                        >
                          {{ field.fileFormat.join(", ") }}
                        </div>
                      </div>
                      <div class="text-truncate" style="width: 13%">
                        <span>{{ field.allowMultiple ? "Yes" : "No" }}</span>
                      </div>
                      <div style="width: 12%">
                        <div class="ct-table-switch">
                          <b-form-checkbox
                            v-model="field.mandatory"
                            switch
                          ></b-form-checkbox>
                        </div>
                      </div>
                      <div style="width: 20%">
                        {{ field.downloadTemplate ? "Yes" : "No" }}
                      </div>
                      <div class="text-center d-flex gap-10" style="width: 10%">
                        <img
                          :class="{
                            'disabled-kanban-img': !field.downloadTemplate,
                            'mr-3': field.createdByRec,
                            'ml-3': !field.createdByRec,
                          }"
                          v-b-tooltip.hover.top="
                            field.downloadTemplate ? 'View' : null
                          "
                          src="@/assets/talentpool/blueEye.svg"
                          alt
                          @click="
                            field.downloadTemplate ? previewDocument(field) : ''
                          "
                          class="pointer"
                        />
                        <img
                          v-if="field.createdByRec"
                          @click="editDoc(field)"
                          v-b-tooltip.hover.top="'Edit'"
                          src="@/assets/talentpool/edit.svg"
                          class="pointer"
                          alt
                        />
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </section>
          </section>

          <hr class="my-0" />

          <div
            class="
              d-flex
              align-items-center
              justify-content-end
              bluebtn
              p-3
              gap-15
            "
          >
            <b-button class="acs-cancelBtn-modal" @click="$emit('close-modal')"
              >Cancel</b-button
            >
            <div class="position-relative">
              <b-button
                :class="showSpinner ? 'disabled-kanban-img' : 'pointer'"
                :disabled="selectedDocs.length == 0"
                @click="
                  selectedDocs.length != 0 && !showSpinner ? requestDocs() : ''
                "
                class="acs-addBtn-modal"
              >
                <span :class="showSpinner && 'hide-text'"
                  >Request Documents</span
                >
              </b-button>
              <div v-if="showSpinner" class="req-doc-loader-pos">
                <Loader />
              </div>
            </div>
          </div>
        </main>
      </b-overlay>
    </b-modal>

    <!-- modal to add new document -->
    <b-modal
      id="addNewDoc"
      centered
      hide-footer
      hide-header
      v-model="showAddNewDoc"
      no-close-on-backdrop
      @hidden="(showAddNewDoc = false), clearForm()"
    >
      <div class="bluebtn">
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="and-head d-flex align-items-center">
            <img
              @click="(showAddNewDoc = false), clearForm()"
              class="mr-2 pointer"
              src="@/assets/img/feedbackform/backarrow.svg"
              alt
            />
            {{ action == "add" ? "Add New" : "Edit" }} Document
          </div>
          <div
            @click="(showAddNewDoc = false), clearForm()"
            class="rotate-on-hover pointer"
          >
            <img
              v-b-tooltip.hover.top="'Close'"
              src="@/assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />
        <div>
          <AddNewDocument
            :documentData="documentData"
            :uploadData="uploadData"
            :validationObj="$v"
            :getSelectedFormatLabels="getSelectedFormatLabels"
            :action="action"
            from="reqDoc"
            :showLoader="showLoader"
            @close-form="(showAddNewDoc = false), clearForm()"
            @select-upload="uploadData = $event"
            @add-document="addDocument"
          />
        </div>
      </div>
    </b-modal>
    <ViewResume
      v-if="viewDoc"
      :label="previewDoc.label"
      :showModal="viewDoc"
      :link="previewDoc.templateLinks[0]"
      from="onboardDoc"
      @close-modal="hideDoc()"
    />
  </main>
</template>

<script>
import {
  getDocumentsTable,
  requestForDocs,
  uploadTemplates,
  downloadAnyFile,
} from "@/utils/apiFunctions";
import AddNewDocument from "../../Documents/AddNewDocument.vue";
import toast from "../../mixin/toast";
import Loader from "../../fixedcomponents/Loader.vue";
import ViewResume from "../../modals/viewResume.vue";
import {
  required,
  requiredIf,
  integer,
  between,
  maxLength,
} from "vuelidate/lib/validators";
import {
  getSelectedFormatLabels,
  generateKey,
} from "@/controllers/commonHelpers";

export default {
  name: "RequestDocs",
  props: {
    candidate: Object,
    jobID: String,
    showRequestDocs: Boolean,
  },
  components: { AddNewDocument, Loader, ViewResume },
  data() {
    return {
      showLoader: false,
      showSpinner: false,
      LoaderStatus: false,
      showAddNewDoc: false,
      allSelected: false,
      viewDoc: false,
      previewDoc: {},
      selectedDocs: [],
      searchQuery: "",
      initalUpload: null,
      action: null,
      sortType: null,
      fullData: [],
      uploadData: [],
      documents: { fields: [] },
      documentData: {
        label: "",
        allowMultiple: false,
        controlType: "upload_file",
        placeholder: null,
        mandatory: false,
        limit: null,
        values: [],
        maxFileSize: null,
        dateTimeFormat: null,
        fileFormat: ["PDF"],
        key: null,
        fieldType: "customField",
        dropdown: false,
        documentStatus: 3,
        multi: false,
        apiEndPoint: null,
        sort: false,
        sortType: null,
        filter: false,
        search: false,
        category: 1,
        seq: null,
        hide: false,
        downloadTemplate: false,
        currentLabel: null,
        template: [],
        uploadedFiles: [],
        createdByRec: true,
        creatorUserID: null,
      },
    };
  },
  mixins: [toast],
  validations() {
    const validateName = (value) => {
      return !this.nameList().some(
        (name) => name.toLowerCase() === value.toLowerCase()
      );
    };
    return {
      documentData: {
        maxFileSize: {
          required,
          integer,
          between: between(1, 20),
        },
        label: {
          required,
          maxLength: maxLength(256),
          validateName: (value) => validateName(value),
        },
        fileFormat: {
          required,
        },
      },
      uploadData: {
        required: requiredIf(() => this.documentData.downloadTemplate),
      },
    };
  },
  created() {
    this.getOnboardingDocs();
  },
  computed: {},
  methods: {
    nameList() {
      return this.fullData
        .filter((obj) => obj.label != this.currentLabel)
        .map((obj) => {
          return obj.label;
        });
    },
    editDoc(field) {
      this.uploadData = this.initalUpload = field.templateLinks;
      this.currentLabel = field.label;
      this.documentData = JSON.parse(JSON.stringify(field));
      this.action = "edit";
      this.showAddNewDoc = true;
    },
    async getPreviewLink() {
      try {
        const res = await downloadAnyFile(this.documentData.template[0]);
        if (res.status == 200) {
          this.documentData.templateLinks = [res.data.data.downloadLink];
        }
      } catch (error) {
        console.error(error);
      }
    },
    generateKey(label) {
      return generateKey(6, label);
    },
    clearForm() {
      this.documentData = {
        label: "",
        controlType: "upload_file",
        placeholder: null,
        mandatory: false,
        limit: null,
        values: [],
        maxFileSize: null,
        dateTimeFormat: null,
        fileFormat: ["PDF"],
        key: null,
        fieldType: "customField",
        dropdown: false,
        documentStatus: 3,
        multi: false,
        apiEndPoint: null,
        sort: false,
        sortType: null,
        filter: false,
        search: false,
        category: 1,
        seq: null,
        hide: false,
        downloadTemplate: false,
        template: [],
        uploadedFiles: [],
        allowMultiple: false,
        createdByRec: true,
        creatorUserID: null,
      };
      this.uploadData = [];
      this.initalUpload = null;
      this.$v.documentData.$reset();
      this.$v.uploadData.$reset();
    },
    async addDocument(differentFileFormat) {
      this.$v.$touch();
      if (!this.$v.$invalid && !differentFileFormat) {
        this.showLoader = true;
        let initialKey = this.documentData.key;
        this.documentData.key = this.generateKey(this.documentData.label);
        if (
          this.uploadData &&
          this.uploadData.length != 0 &&
          this.initalUpload != this.uploadData
        )
          await this.uploadTemplates();
        if (this.action == "add")
          this.documents.fields = [
            ...[this.documentData],
            ...this.documents.fields,
          ];
        else {
          console.log(this.documentData);
          if (!this.documentData.downloadTemplate)
            this.documentData.template =
              this.documentData.templateLinks =
              this.uploadData =
                [];
          const index = this.documents.fields.findIndex(
            (obj) => obj.key === initialKey
          );
          if (index !== -1) {
            this.documents.fields.splice(index, 1, this.documentData);
          }
        }
        if (this.selectedDocs.includes(initialKey)) {
          let indexval = this.selectedDocs.indexOf(initialKey);
          this.selectedDocs.splice(indexval, 1, this.documentData.key);
        }
        this.fullData = this.documents.fields;
        this.$forceUpdate();
        this.showAddNewDoc = false;
        this.clearForm();
        this.showLoader = false;
      }
    },
    async uploadTemplates() {
      try {
        let path = `${this.documents.licenseKey}/onboardingTemplates/${this.documentData.key}`;
        let form = new FormData();
        form.append("file", this.uploadData);
        form.append("path", path);
        let res = await uploadTemplates(form);
        if (res.status === 200) {
          this.documentData.template = [];
          this.documentData.template.push(res.data.data.file_path);
          await this.getPreviewLink();
        }
      } catch (error) {
        console.error(error);
      }
    },
    getSelectedFormatLabels(arr1) {
      return getSelectedFormatLabels(arr1);
    },
    previewDocument(doc) {
      this.previewDoc = doc;
      this.viewDoc = true;
    },
    hideDoc() {
      this.viewDoc = false;
      this.previewLink = {};
    },
    async requestDocs() {
      try {
        this.showSpinner = true;
        let documents = this.getSelectedDocs();
        let payload = {
          candidateID: this.candidate.candidateID,
          jobID: this.jobID,
          fields: documents,
        };
        const res = await requestForDocs(payload);
        if (res.status == 200) {
          this.$emit("close-modal");
          this.$emit("update-details");
          this.dynamicToast(
            "success",
            `Successfully requested`,
            `Documents requested to "${this.candidate.name}" sucessfully.`
          );
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
      } finally {
        this.showSpinner = false;
      }
    },
    getSelectedDocs() {
      return this.documents.fields.filter((obj) =>
        this.selectedDocs.includes(obj.key)
      );
    },
    selectAllDocs() {
      if (this.allSelected)
        this.selectedDocs = this.documents.fields.map((obj) => {
          return obj.key;
        });
      else this.selectedDocs = [];
      this.deselect();
    },
    deselect() {
      this.allSelected = false;
      const containsAll = this.documents.fields.every((element) => {
        return this.selectedDocs.includes(element.key);
      });
      if (containsAll) {
        this.allSelected = true;
      }
    },
    searchDocs() {
      const lowerCaseValue = this.searchQuery.toLowerCase();
      this.documents.fields = this.fullData.filter(
        (item) =>
          item.label &&
          item.label.toString().toLowerCase().includes(lowerCaseValue)
      );
      if (this.documents.fields.length == 0 && !this.searchQuery) {
        this.documents.fields = this.fullData;
      }
    },
    sortObjectsByKey(type) {
      this.sortType = type;
      this.documents.fields = this.documents.fields.slice().sort((a, b) => {
        let valueA = a.label;
        let valueB = b.label;
        valueA = valueA ? valueA.toString().toLowerCase() : valueA;
        valueB = valueB ? valueB.toString().toLowerCase() : valueB;
        if (valueA < valueB) return this.sortType === true ? -1 : 1;
        if (valueA > valueB) return this.sortType === true ? 1 : -1;
        return 0;
      });
    },
    async getOnboardingDocs() {
      this.LoaderStatus = true;
      try {
        const res = await getDocumentsTable({ parentID: 6, kanban: true });
        if (res.status == 200) {
          this.documents = res.data.data;
          this.fullData = res.data.data.fields;
          this.$forceUpdate();
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.LoaderStatus = false;
      }
    },
  },
};
</script>

<style>
.req-doc-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 46px;
}
.table-sort-icons {
  margin-top: -2px;
}
.reqdocs-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: var(--bluetheme);
  font-family: var(--lato);
  padding: 16px 0px;
  margin: 8px 0px;
  cursor: default;
}

.reqdocs-table-row:hover {
  background: #e7e8f5;
}

.padding-6-30 {
  padding: 6px 30px !important;
}

.hide-text {
  visibility: hidden;
}

#addNewDoc .modal-body {
  padding: 0;
}
.and-head {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #344054;
}
.and-overflow {
  height: calc(100vh - 280px);
  max-height: 590px;
  overflow: auto;
}
</style>
